// Schema.org JSON-LD injection (kept separate from the runtime OG/Twitter tag mutation).
// Exactly one managed JSON-LD script tag is kept in the head for the active route.

import { getSiteOrigin, BRAND_IMAGE, CATALOG_DESCRIPTION } from '@/lib/seo';

const SCRIPT_ID = 'readdy-route-jsonld';

function catalogSchema(): Record<string, unknown> {
  const origin = getSiteOrigin();
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Catálogo de Productos',
    url: origin ? `${origin}/catalogo` : undefined,
    description: CATALOG_DESCRIPTION,
    inLanguage: 'es',
    image: BRAND_IMAGE,
  };
}

const schemaByRoute: Record<string, () => Record<string, unknown>> = {
  '/catalogo': catalogSchema,
};

export function applySchema(pathname: string): void {
  if (typeof document === 'undefined') return;

  const existing = document.getElementById(SCRIPT_ID);
  if (existing) existing.remove();

  const builder = schemaByRoute[pathname];
  if (!builder) return;

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = SCRIPT_ID;
  script.textContent = JSON.stringify(builder());
  document.head.appendChild(script);
}